<template lang="pug">
  div.px-4.py-3.d-flex.align-center
    y-checkbox.mb-n3.mr-n2(v-model="checkbox" style="height:30px" :disabled="allItems.length === 0" @change="$emit('updateAll', $event)")
    //- For toProcess tab
    v-btn.button-AA-tiny.basic100--text(v-if="currentTab === '#toProcess'" depressed small color="info500" height="24" :loading="isFetching || isLoading" :disabled="selectedItems.length === 0" @click="$emit('process')") Process
      span.ml-1(v-if="selectedItems.length > 0") ({{ selectedItems.length }})
    //- For processing tab
    v-menu(v-if="currentTab === '#processing'" left offset-y)
      template(v-slot:activator="{ on, attrs }")
        v-btn.button-AA-tiny.basic100--text(depressed small color="info500" height="24" :loading="isFetching || isLoading" :disabled="selectedItems.length === 0" v-on="on") Action
          span.ml-1(v-if="selectedItems.length > 0") ({{ selectedItems.length }})
      v-list(dense)
        template
          v-list-item(@click="$emit('export')")
            v-list-item-title.s2.basic800--text Export selected
          v-list-item(@click="$emit('markAsPaid')")
            v-list-item-title.s2.basic800--text Mark as paid
    //- For processing tab
    v-menu(v-if="currentTab === '#completed'" left offset-y)
      template(v-slot:activator="{ on, attrs }")
        v-btn.button-AA-tiny.basic100--text(depressed small color="info500" height="24" :loading="isFetching || isLoading" :disabled="selectedItems.length === 0" v-on="on") Action
          span.ml-1(v-if="selectedItems.length > 0") ({{ selectedItems.length }})
      v-list(dense)
        template
          v-list-item(@click="$emit('archived')")
            v-list-item-title.s2.basic800--text Archived selected
</template>

<script>
export default {
  name: 'PayoutBulkActions',
  props: {
    isFetching: {
      type: Boolean
    },
    isLoading: {
      type: Boolean
    },
    selectedItems: {
      type: Array,
      required: true
    },
    allItems: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      checkbox: false
    }
  },
  computed: {
    selectedIds() {
      return this.selectedItems.map(item => item.id)
    },
    allIds() {
      return this.allItems.map(item => item.id)
    },
    currentTab() {
      return this.$route.hash
    }
  },
  watch: {
    isFetching() {
      this.checkStatus()
    },
    selectedIds: {
      handler() {
        this.checkStatus()
      },
      deep: true
    }
  },
  methods: {
    checkStatus() {
      if (this.allIds.length === 0) {
        this.checkbox = false
        return
      }
      this.checkbox = this.allIds.every(item => this.selectedIds.includes(item))
    }
  },
}
</script>

<style scoped>
</style>